/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateShareCopyResponse
 */
export interface GenerateShareCopyResponse {
    /**
     * 
     * @type {string}
     * @memberof GenerateShareCopyResponse
     */
    copy: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateShareCopyResponse
     */
    model?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateShareCopyResponse
     */
    fallback?: boolean;
}

/**
 * Check if a given object implements the GenerateShareCopyResponse interface.
 */
export function instanceOfGenerateShareCopyResponse(value: object): value is GenerateShareCopyResponse {
    if (!('copy' in value) || value['copy'] === undefined) return false;
    return true;
}

export function GenerateShareCopyResponseFromJSON(json: any): GenerateShareCopyResponse {
    return GenerateShareCopyResponseFromJSONTyped(json, false);
}

export function GenerateShareCopyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateShareCopyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'copy': json['copy'],
        'model': json['model'] == null ? undefined : json['model'],
        'fallback': json['fallback'] == null ? undefined : json['fallback'],
    };
}

export function GenerateShareCopyResponseToJSON(json: any): GenerateShareCopyResponse {
    return GenerateShareCopyResponseToJSONTyped(json, false);
}

export function GenerateShareCopyResponseToJSONTyped(value?: GenerateShareCopyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'copy': value['copy'],
        'model': value['model'],
        'fallback': value['fallback'],
    };
}

